import { useSelector } from 'react-redux';
import { getSession } from '../../SessionProvider/redux/selectors';
import { PapiDeviation } from '@wix/da-papi-types';

export function useMetaRobots(directives?: string, deviation?: PapiDeviation) {
  const session = useSelector(getSession);
  const robots = session?.seo?.robots;
  return getRobotsContent(directives, robots, deviation);
}

export function getRobotsContent(directives, robots, deviation) {
  const out: string[] = [];
  // Default
  out.push('max-image-preview:large');
  // Robots from backend
  if (robots) {
    out.push(robots);
  }
  // No AI
  if (deviation?.isAiUseDisallowed) {
    out.push('noimageai');
  }
  return `${out.join(',')}${directives ? `, ${directives}` : ''}`;
}
